import { api } from '@/lib/api';

type ThreadRecord = {
  id: string;
};

interface PostEntityThreadNoteInput {
  entityType: string;
  entityId: string;
  content: string;
}

export async function postEntityThreadNote(input: PostEntityThreadNoteInput): Promise<void> {
  const ensuredThread = await api.post<ThreadRecord>(
    `/chat-threads/entity/${encodeURIComponent(input.entityType)}/${encodeURIComponent(input.entityId)}`,
    {},
  );

  await api.post(`/chat-threads/${ensuredThread.id}/messages`, {
    content: input.content,
    contentType: 'text',
  });
}
